import abc from "./perso-02.png";
import abc2x from "./perso-02@2x.png";
import abc3x from "./perso-02@3x.png";

export const abcSrc = { src: abc, srcSet: `${abc2x} 2x, ${abc3x} 3x` };
